import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ba from 'vue-ba'
import 'lib-flexible'

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()

import '@/permission.js'

Vue.config.productionTip = false

Vue.use(ba, { siteId: '6fc92d710837972b40b7aea20e30d0d1', src: 'https://hm.baidu.com/hm.js?6fc92d710837972b40b7aea20e30d0d1' })

new Vue({
  router,
  store,
  // vConsole,
  render: (h) => h(App),
}).$mount('#app')
